module.exports = __webpack_public_path__ + "static/media/credit-card.016a2879.svg";